export default [
  {
    path: 'logs/:object/:id',
    name: 'Logs',
    component: () => import('@/app/logs/views/LogsView.vue'),
  },
];